import { render, staticRenderFns } from "./ReactionMenu.vue?vue&type=template&id=3d9e7a01&scoped=true"
import script from "./ReactionMenu.vue?vue&type=script&lang=js"
export * from "./ReactionMenu.vue?vue&type=script&lang=js"
import style0 from "./ReactionMenu.vue?vue&type=style&index=0&id=3d9e7a01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9e7a01",
  null
  
)

export default component.exports